module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.shadeNum > 0) ? _c('div', {
    staticClass: "pop_wrap"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLogin) ? _c('v-headinfo') : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('v-leftmenu') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "container"
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "container"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('dialogImageAddTag'), _vm._v(" "), _c('dialogOrderImg')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pop_div"
  }, [_c('div', {
    staticClass: "pop"
  }, [_c('main', [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader-inner pacman"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02dac517","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 559
// module chunks = 64